import { KDiagramStaticData, RangeData, ShoptestData, SeaTrialsData, SeaTrialsMeasurments, SeaTrialsCoefficients } from "./data";

export function mapKDiagramStaticDataFromJson(json) {
  return new KDiagramStaticData(
    new RangeData(
      json["range"]["BSR_upper"],
      json["range"]["nMCR"],
      json["range"]["MCR"]
    ),
    new ShoptestData(
      json["shoptests"]["rpm"],
      json["shoptests"]["power"]
    ),
  );
}

export function mapSeaTrialsDataFromJson(json) {
  return json.map((datum) => {
    return new SeaTrialsData(
      datum["id"],
      datum["meanDraft"],
      datum["vesselId"],
      datum["data"].map((datum) => new SeaTrialsMeasurments(
        datum["rpm"],
        datum["power"],
        datum["speed"],
        datum["bsfc"]
      )),
      new SeaTrialsCoefficients(
        datum["coefficients"]["cPowerStw"],
        datum["coefficients"]["nPowerStw"],
        datum["coefficients"]["cPowerRpm"],
        datum["coefficients"]["nPowerRpm"],
        datum["coefficients"]["cRpmStw"],
        datum["coefficients"]["nRpmStw"],
        datum["coefficients"]["cStwRpm"],
        datum["coefficients"]["nStwRpm"]
      )
    );});
}
